@if ((loading$ | async) === false) {
  @if (type === undefined) {
    <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
  } @else if (type === 'inAppBudget') {
    <ng-container *ngTemplateOutlet="BudgetTemplate"></ng-container>
  } @else {
    <ng-container *ngTemplateOutlet="EDCTemplate"></ng-container>
  }
} @else {
  @if (type === 'edc') {
    <ng-container *ngTemplateOutlet="edcLoading"></ng-container>
  } @else {
    <ng-container *ngTemplateOutlet="defaultLoading"></ng-container>
  }
}

<ng-template #defaultLoading>
  <div class="mt-4 w-full max-w-sm rounded-md border border-blue-200 p-2 shadow">
    <div class="flex animate-pulse space-x-4">
      <div class="flex-1 space-y-4 py-1">
        <div class="flex justify-between">
          <div class="h-8 w-7 rounded bg-blue-200"></div>
          <div class="grow"></div>
          <div class="h-4 w-1/6 rounded bg-blue-200"></div>
        </div>
        <div class="space-y-2">
          <div class="h-3 w-3/6 rounded bg-blue-200"></div>
          <div class="h-0.5"></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #defaultTemplate>
  @for (file of files$ | async; track file; let first = $first) {
    <section
      class="relative mt-4 h-32 rounded-md border-2 p-2"
      [ngClass]="{ 'mt-4': disableFirstFileMargin ? !first : true }"
    >
      <div class="flex h-6 items-center justify-between">
        <aux-icon name="FileDescription" class="-ml-1" />
        <div class="flex h-6 items-center justify-between">
          <button
            class="mr-2 flex h-6 w-6 items-center justify-center text-aux-blue"
            type="button"
            auxTooltip="Download"
            (click)="onDownload(file)"
          >
            <aux-icon name="Download" />
          </button>
          <button
            type="button"
            class="btn--hyperlink px-0 focus:outline-none"
            (click)="onRemove(file)"
          >
            Remove
          </button>
        </div>
      </div>
      <div class="mt-2 h-12">
        <div
          class="line-clamp-2 block truncate font-semibold"
          #fileText
          [auxTooltip]="fileText.offsetWidth < fileText.scrollWidth ? file.fileName : ''"
        >
          {{ file.fileName }}
        </div>

        @if (file.created_by && file.create_date && showUserAndDate) {
          <div class="line-clamp-2 italic">
            Uploaded By: {{ userFormatter(file.created_by) }}
            {{ file.create_date | date }}
          </div>
        }
        <ng-content></ng-content>
      </div>
    </section>
  }
</ng-template>

<ng-template #edcLoading>
  <div class="mt-4 w-full rounded-md border border-blue-200 p-2 shadow">
    <div class="flex animate-pulse space-x-4">
      <div class="flex-1 space-y-4 py-1">
        <div class="flex justify-between">
          <div class="h-8 w-7 rounded bg-blue-200"></div>
          <div class="grow"></div>
          <div class="h-4 w-1/6 rounded bg-blue-200"></div>
        </div>
        <div class="space-y-2">
          <div class="h-3 w-3/6 rounded bg-blue-200"></div>
          <div class="h-0.5"></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #BudgetTemplate>
  @for (file of files$ | async; track file; let first = $first) {
    <section
      class="relative mt-4 flex min-h-12 items-center rounded-md border-2 border-gray-200 px-2"
      [ngClass]="{ 'mt-4': disableFirstFileMargin ? !first : true }"
    >
      <div class="flex w-full items-center justify-between">
        <div class="flex items-center justify-start">
          <aux-icon name="FileDescription" class="-ml-1 mr-1 min-w-[24px]" />
          <div class="h-fit max-w-[280px] break-all">
            {{ file.fileName }}
          </div>
        </div>
        <div class="flex items-center space-x-2">
          <button
            class="mr-2 flex h-6 w-6 items-center justify-center text-aux-blue"
            type="button"
            auxTooltip="Download"
            (click)="onDownload(file)"
          >
            <aux-icon name="Download" />
          </button>
          <button
            type="button"
            class="h-6 w-6 items-center justify-center"
            (click)="onRemove(file)"
          >
            <aux-icon class="cursor-pointer text-aux-error" name="Trash" />
          </button>
        </div>
      </div>
    </section>
  }
</ng-template>

<ng-template #EDCTemplate>
  @for (file of files$ | async; track file; let first = $first) {
    <section
      class="relative mt-4 flex min-h-12 items-center rounded-md border-2 border-gray-200 p-2"
      [ngClass]="{ 'mt-4': disableFirstFileMargin ? !first : true }"
    >
      <div class="flex w-full items-center justify-between">
        <div class="flex flex-col items-start justify-between space-y-1">
          <div class="h-fit max-w-[280px] break-all text-sm font-bold">
            {{ file.fileName }}
          </div>
          <div class="flex flex-col space-y-1 text-sm italic text-aux-gray-dark-100">
            @if (file.created_by && file.create_date && showUserAndDate) {
              <div class="line-clamp-2">
                Uploaded By: {{ userFormatter(file.created_by) }}
                {{ file.create_date | date }}
              </div>
            }
          </div>
        </div>
        <div class="flex items-center space-x-2">
          <button
            class="mr-2 flex h-6 w-6 items-center justify-center text-aux-blue"
            type="button"
            auxTooltip="Download"
            (click)="onDownload(file)"
          >
            <aux-icon name="Download" />
          </button>
          <button
            type="button"
            class="h-6 w-6 items-center justify-center"
            [disabled]="file.created_by !== getloggedInUserSub() && file.uploaded"
            [ngClass]="{
              'cursor-not-allowed opacity-50':
                file.created_by !== getloggedInUserSub() && file.uploaded,
            }"
            [auxTooltip]="
              file.created_by !== getloggedInUserSub() && file.uploaded
                ? 'You can only delete documents that you uploaded.'
                : ''
            "
            (click)="onRemove(file)"
          >
            <aux-icon class="text-aux-error" name="Trash" />
          </button>
        </div>
      </div>
    </section>
  }
</ng-template>
